export const financeV2Route = [
    {
        path: '/finance/v2',
        component: () => import('@/views/finance/OrderKidsV2/OrderKidsV2.vue'),

    },
    {
        path: '/finance/tuition-group-by-excel',
        component: () => import('@/components/FinanceVer2/ByGroup/TuitionServiceByExcel2.vue')
    },
    {
        path: '/finance/tuition-statistics',
        component: () => import('@/views/finance/TuitionStatistics/layout.vue')
    },

    {
        path: '/finance/tuition-statistics/charts',
        component: () => import('@/components/FinanceVer2/TuitionStatistics/StatisticsChart.vue')
    },

    {
        path: '/finance/employee/salary/new',
        component: () => import('@/views/finance/OrderKidsV2/EmployeeSalaryV2.vue')
    },

    {
        path: '/finance/employee/static-salary/new',
        component: () => import('@/components/FinanceVer2/employeeStatistics/StatisticsChartEmployeeSalary.vue')
    },
    {
        path: '/finance/manage/packages',
        component: () => import('@/components/FinanceVer2/managePackages/ManagePackages.vue')
    },
    {
        path: '/finance/manage/tuition-management',
        component: () => import('@/components/FinanceVer2/TuitionManagement/TuitionManagement.vue')
    },
    {
        path: '/finance/manage/register-revenue',
        component: () => import('@/components/FinanceVer2/TuitionManagement/RegisterRevenue.vue')
    },
    {
        path: '/finance/manage/initialize-class-tuition',
        component: () => import('@/components/FinanceVer2/TuitionManagement/InitializeClassTuition.vue')
    },
    {
        path: '/finance/manage/initialize-group-tuition',
        component: () => import('@/components/FinanceVer2/TuitionManagement/InitializeGroupTuition.vue')
    },
    {
        path: '/finance/manage-v3/packages',
        component: () => import('@/components/tutition_v3/ManagingPackage.vue')
    },
    {
        path: '/finance/manage-v3/tuition-statistics',
        component: () => import('@/components/tutition_v3/ManagingTuitionStatistic.vue')
    },
    {
        path: '/finance/manage-v3/student-invoice-summary',
        component: () => import('@/components/tutition_v3/StudentInvoiceSummary.vue')
    },
    {
        path: '/finance/manage-v3/principal-revenues',
        component: () => import('@/components/tutition_v3/ManagingPrincipalRevenue.vue')
    },
    {
        path: '/finance/manage-v3/revenue-scopes',
        component: () => import('@/components/tutition_v3/ManagingRevenueScope.vue')
    },
    {
        path: '/finance/manage-v3/total-revenues',
        component: () => import('@/components/tutition_v3/ManagingTotalRevenue.vue')
    },
    {
        path: '/finance/manage-v3/managing-revenue',
        component: () => import('@/components/tutition_v3/ManagingRevenue.vue')
    },
    {
        path: '/finance/manage-v3/draft-invoice',
        component: () => import('@/components/tutition_v3/TuitionDraftInvoice.vue')
    },
    {
        path: '/finance/manage-v3/student-invoices',
        component: () => import('@/components/tutition_v3/ManagingStudentInvoice.vue')
    },
    {
        path: '/finance/manage-v3/tuition-statistics/charts',
        component: () => import('@/components/tutition_v3/ManagingTuitionStatisticChart.vue')
    },
]
